"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dom = require("./utils/dom");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TRIGGER_EVENTS = ['resize', 'scroll', 'load'];

var StickyContainer = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(StickyContainer, _PureComponent);

  function StickyContainer(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      sticky: false,
      height: null
    };
    _this.bindDOMRef = _this.bindDOMRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getDistanceFromTop = _this.getDistanceFromTop.bind((0, _assertThisInitialized2["default"])(_this));
    _this.recomputeState = _this.recomputeState.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = StickyContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    (0, _dom.on)(TRIGGER_EVENTS, this.recomputeState);
    this.recomputeState();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    (0, _dom.off)(TRIGGER_EVENTS, this.recomputeState);
  };

  _proto.getDistanceFromTop = function getDistanceFromTop() {
    return Math.round((0, _dom.getBoundingClientRect)(this.instance).top);
  };

  _proto.recomputeState = function recomputeState() {
    var scrollTop = Math.min(0, window.pageYOffset);
    var fromTop = this.getDistanceFromTop() + scrollTop;
    var sticky = fromTop <= 0;

    var _ref = this.props.collapse ? 0 : (0, _dom.getBoundingClientRect)(this.instance.firstChild),
        height = _ref.height;

    if (sticky !== this.state.sticky || height !== this.state.height) {
      this.setState({
        sticky: sticky,
        height: height
      });
    }
  };

  _proto.bindDOMRef = function bindDOMRef(ref) {
    this.instance = ref;
  };

  _proto.render = function render() {
    var _this$state = this.state,
        sticky = _this$state.sticky,
        height = _this$state.height;
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.bindDOMRef,
      style: {
        height: height
      },
      className: (0, _classnames["default"])('sticky-container', {
        sticky: sticky
      })
    }, this.props.children);
  };

  return StickyContainer;
}(_react.PureComponent);

exports["default"] = StickyContainer;
StickyContainer.propTypes = {
  children: _propTypes["default"].node,
  collapse: _propTypes["default"].bool
};